import { animate, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BookingModel, BookingService, NavigationService } from 'app-components';
import { AppSettingsService, AppTypeSettings } from 't4-app-integration';
import { LocationInfo, PageBase } from 't4core';

@Component({
  selector: 'app-OpenApp',
  templateUrl: './OpenApp.html',
    standalone: false
})
export class OpenAppComponent extends PageBase implements OnInit {

  constructor(public appSettings: AppSettingsService, el: ElementRef)
  {
    super(el);
  }

  async ngOnInit() {
  }
}
